import { Tabs } from '@mantine/core';
import React from 'react';

import { Book, BookStatusTabEnum } from '@/entities/books/model/types';

import { BookTable } from './book-table';
import styles from './book-tabs.module.scss';

interface BookTabsProps {
  activeTab: BookStatusTabEnum;
  books: Book[];
  onTabChange: (value: string | null) => void;
  setBooksList: (books: Book[]) => void;
  loading?: boolean;
}

export const BookTabs: React.FC<BookTabsProps> = ({
  activeTab,
  books,
  onTabChange,
  setBooksList,
  loading = false,
}) => {
  return (
    <Tabs value={activeTab} onChange={onTabChange} w="100%">
      <Tabs.List className={styles.tabList}>
        <Tabs.Tab className={styles.tab} value={BookStatusTabEnum.All}>
          Все
        </Tabs.Tab>
        <Tabs.Tab className={styles.tab} value={BookStatusTabEnum.Published}>
          Опубликовано
        </Tabs.Tab>
        <Tabs.Tab className={styles.tab} value={BookStatusTabEnum.Draft}>
          Черновик
        </Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value={BookStatusTabEnum.All} className={styles.panel}>
        <BookTable
          books={books}
          setBooksList={setBooksList}
          loading={loading}
        />
      </Tabs.Panel>
      <Tabs.Panel value={BookStatusTabEnum.Published}>
        <BookTable
          books={books}
          setBooksList={setBooksList}
          loading={loading}
        />
      </Tabs.Panel>
      <Tabs.Panel value={BookStatusTabEnum.Draft}>
        <BookTable
          books={books}
          setBooksList={setBooksList}
          loading={loading}
        />
      </Tabs.Panel>
    </Tabs>
  );
};
